import { useApiQuery, useApiMutation } from "../services/react-query.js";

export const useGetStations = (eventId) => {
  return useApiQuery({
    queryOptions: {
      queryKey: ["checkInStations", eventId],
      enabled: !!eventId,
    },
    fetchOptions: {
      url: "/check-in/stations",
      method: "GET",
      params: { eventId },
    },
  });
};

export const useGetStationByCode = (code) => {
  return useApiQuery({
    queryOptions: {
      queryKey: ["checkInStation", code],
      enabled: !!code,
    },
    fetchOptions: {
      url: `/check-in/stations/code/${code}`,
      method: "GET",
    },
  });
};

export const useGetStationActivity = (id) => {
  return useApiQuery({
    queryOptions: {
      queryKey: ["checkInStationActivity", id],
      enabled: !!id,
      refetchInterval: 1000,
    },
    fetchOptions: {
      url: `/check-in/stations/${id}/activity`,
      method: "GET",
    },
  });
};

export const useMarkScanDisplayed = (scanId) => {
  return useApiMutation({
    mutationOptions: {
      mutationKey: ["markScanDisplayed", scanId],
    },
    fetchOptions: {
      url: `/check-in/scans/${scanId}/displayed`,
      method: "PATCH",
    },
    // The activity query already polls every second; invalidating here only
    // adds a redundant refetch per scan.
    invalidateQueryKeys: [],
    hideNotification: true,
  });
};

export const useCreateScan = () => {
  return useApiMutation({
    mutationOptions: {
      mutationKey: ["createCheckInScan"],
    },
    fetchOptions: {
      url: "/check-in/scans",
      method: "POST",
    },
    // The scan reaches the station through the activity poll.
    invalidateQueryKeys: [],
    hideNotification: true,
  });
};

export const useCreateStation = () => {
  return useApiMutation({
    mutationOptions: {
      mutationKey: ["createCheckInStation"],
    },
    fetchOptions: {
      url: "/check-in/stations",
      method: "POST",
    },
    invalidateQueryKeys: [["checkInStations"]],
    successMessage: { title: "Station was created successfully." },
  });
};

export const useUpdateStation = (id) => {
  return useApiMutation({
    mutationOptions: {
      mutationKey: ["updateCheckInStation", id],
    },
    fetchOptions: {
      url: `/check-in/stations/${id}`,
      method: "PATCH",
    },
    invalidateQueryKeys: [["checkInStations"]],
    successMessage: { title: "Station was updated successfully" },
  });
};

export const useCloseStation = (id) => {
  return useApiMutation({
    mutationOptions: {
      mutationKey: ["closeCheckInStation", id],
    },
    fetchOptions: {
      url: `/check-in/stations/${id}/close`,
      method: "PATCH",
    },
    invalidateQueryKeys: [["checkInStations"]],
    successMessage: { title: "Station was closed." },
  });
};
